// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/footers.scss
// module id = 876
// module chunks = 0